export default __webpack_public_path__ + "static/media/img5.5088d4c5.PNG";